var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"success-seminar"},[_c('div',{staticClass:"success-seminar__wrap"},[(_vm.seminarDetails.title)?_c('h2',{domProps:{"innerHTML":_vm._s(_vm.seminarDetails.title)}}):_vm._e(),_c('div',{class:{ emptyTitle: !_vm.seminarDetails.title },domProps:{"innerHTML":_vm._s(_vm.seminarDetails.detail)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }